/**
 * RTC Mega Menu — Sport > State > Area Code
 * Desktop: Left panel always shows sport list, right panel switches image → states → codes
 * Mobile: Full-width stacked screens with slide transitions
 * Sets identity cookies and navigates to collection pages
 */
(function() {
  'use strict';

  // ============================================
  // Area Code Database
  // ============================================
  var STATE_CODES = {
    "Alabama": ["205","251","256","334","483","659","938"],
    "Alaska": ["907"],
    "Arizona": ["480","520","602","623","928"],
    "Arkansas": ["327","479","501","870"],
    "California": ["209","213","279","310","323","341","350","357","369","408","415","424","442","510","530","559","562","619","626","628","650","657","661","669","707","714","738","747","760","805","818","820","831","837","840","858","909","916","925","949","951"],
    "Canada": ["204","226","236","249","250","257","263","289","306","343","354","365","367","368","382","403","416","418","428","431","437","438","450","468","474","506","514","519","548","579","581","584","587","604","613","639","647","672","683","705","709","742","753","778","780","782","807","819","825","867","873","879","902","905","942"],
    "Caribbean": ["242","246","264","268","340","441","473"],
    "Colorado": ["303","719","720","748","970","983"],
    "Connecticut": ["203","475","860","959"],
    "Delaware": ["302"],
    "Florida": ["239","305","321","324","352","386","407","448","561","645","656","689","727","728","754","772","786","813","850","863","904","941","954"],
    "Georgia": ["229","404","470","478","678","706","762","770","912","943"],
    "Hawaii": ["808"],
    "Idaho": ["208","986"],
    "Illinois": ["217","224","309","312","331","447","464","618","630","708","730","773","779","815","847","861","872"],
    "Indiana": ["219","260","317","463","574","765","812","930"],
    "Iowa": ["319","515","563","641","712"],
    "Kansas": ["316","620","785","913"],
    "Kentucky": ["270","364","502","606","859"],
    "Louisiana": ["225","318","337","457","504","985"],
    "Maine": ["207"],
    "Maryland": ["227","240","301","410","443","667"],
    "Massachusetts": ["339","351","413","508","617","774","781","857","978"],
    "Michigan": ["231","248","269","313","517","586","616","679","734","810","906","947","989"],
    "Minnesota": ["218","320","507","612","651","763","924","952"],
    "Mississippi": ["228","601","662","769"],
    "Missouri": ["235","314","417","557","573","636","660","816","975"],
    "Montana": ["406"],
    "Nebraska": ["308","402","531"],
    "Nevada": ["702","725","775"],
    "New Hampshire": ["603"],
    "New Jersey": ["201","551","609","640","732","848","856","862","908","973"],
    "New Mexico": ["505","575"],
    "New York": ["212","315","329","332","347","363","516","518","585","607","624","631","646","680","716","718","838","845","914","917","929","934"],
    "North Carolina": ["252","336","472","704","743","828","910","919","980","984"],
    "North Dakota": ["701"],
    "Ohio": ["216","220","234","283","326","330","380","419","436","440","513","567","614","740","937"],
    "Oklahoma": ["405","539","572","580","918"],
    "Oregon": ["458","503","541","971"],
    "Pennsylvania": ["215","223","267","272","412","445","484","570","582","610","717","724","814","835","878"],
    "Puerto Rico": ["787","939"],
    "Rhode Island": ["401"],
    "South Carolina": ["803","821","839","843","854","864"],
    "South Dakota": ["605"],
    "Tennessee": ["423","615","629","729","731","865","901","931"],
    "Territories": ["671","684"],
    "Texas": ["210","214","254","281","325","346","361","409","430","432","469","512","621","682","713","726","737","806","817","830","832","903","915","936","940","945","956","972","979"],
    "Utah": ["385","435","801"],
    "Vermont": ["802"],
    "Virginia": ["276","434","540","571","686","703","757","804","826","948"],
    "Washington": ["206","253","360","425","509","564"],
    "Washington, D.C.": ["202","771"],
    "West Virginia": ["304","681"],
    "Wisconsin": ["262","274","353","414","534","608","715","920"],
    "Wyoming": ["307"]
  };

  // ============================================
  // State
  // ============================================
  var currentSport = null;
  var currentState = null;
  var container = null;

  // ============================================
  // Breakpoint helper
  // ============================================
  function isMobile() {
    return window.innerWidth <= 749;
  }

  // ============================================
  // Cookie helpers
  // ============================================
  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setDate(expires.getDate() + (days || 30));
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + expires.toUTCString() +
      ';path=/;SameSite=Lax';
  }

  // ============================================
  // Right panel view switching (desktop)
  // ============================================
  function showView(viewName) {
    if (!container) return;
    var views = container.querySelectorAll('[data-view]');
    views.forEach(function(view) {
      if (view.getAttribute('data-view') === viewName) {
        view.classList.add('is-active');
      } else {
        view.classList.remove('is-active');
      }
    });
  }

  // ============================================
  // Mobile screen switching
  // ============================================
  function showMobileScreen(screenName) {
    if (!container) return;
    var screens = container.querySelectorAll('[data-mobile-screen]');
    screens.forEach(function(screen) {
      if (screen.getAttribute('data-mobile-screen') === screenName) {
        screen.classList.add('is-active');
      } else {
        screen.classList.remove('is-active');
      }
    });

    // Add/remove drill class on container to push main panel
    if (screenName) {
      container.classList.add('mobile-drill');
    } else {
      container.classList.remove('mobile-drill');
    }
  }

  function hideMobileScreens() {
    if (!container) return;
    container.querySelectorAll('[data-mobile-screen]').forEach(function(screen) {
      screen.classList.remove('is-active');
    });
    container.classList.remove('mobile-drill');
  }

  // ============================================
  // Capitalize helper
  // ============================================
  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // ============================================
  // Build the collection URL for a sport + area code.
  // Sports listed here use the new smart-collection + tag pattern (/collections/SPORT/CODE).
  // All other sports fall back to the legacy handle (/collections/CODE-SPORT) until they're migrated.
  // ============================================
  var NEW_URL_SPORTS = ['training', 'running', 'baseball', 'basketball', 'football', 'lacrosse', 'soccer', 'softball', 'volleyball', 'hockey', 'wrestling', 'track-and-field', 'tennis', 'golf', 'swim-and-dive', 'media'];
  function buildCollectionHref(sport, code) {
    if (NEW_URL_SPORTS.indexOf(sport) !== -1) {
      return '/collections/' + sport + '/' + code;
    }
    return '/collections/' + code + '-' + sport;
  }

  // ============================================
  // Format sport name for display
  // ============================================
  function formatSport(handle) {
    var map = {
      'baseball': 'Baseball',
      'football': 'Football',
      'basketball': 'Basketball',
      'softball': 'Softball',
      'volleyball': 'Volleyball',
      'lacrosse': 'Lacrosse',
      'hockey': 'Hockey',
      'wrestling': 'Wrestling',
      'soccer': 'Soccer',
      'running': 'Running',
      'training': 'Training',
      'track-and-field': 'Track & Field',
      'swim-and-dive': 'Swim & Dive',
      'golf': 'Golf',
      'tennis': 'Tennis',
      'media': 'Media'
    };
    return map[handle] || capitalize(handle);
  }

  // ============================================
  // Highlight active sport in left panel
  // ============================================
  function highlightSport(sport) {
    container.querySelectorAll('[data-sport]').forEach(function(btn) {
      if (btn.getAttribute('data-sport') === sport) {
        btn.classList.add('is-active-sport');
      } else {
        btn.classList.remove('is-active-sport');
      }
    });
  }

  function clearHighlight() {
    container.querySelectorAll('[data-sport]').forEach(function(btn) {
      btn.classList.remove('is-active-sport');
    });
  }

  // ============================================
  // Build state list (desktop — right panel)
  // ============================================
  function buildStateList() {
    var listEl = container.querySelector('[data-states-list]');
    var html = '';
    var states = Object.keys(STATE_CODES).sort();
    states.forEach(function(state) {
      html += '<button class="rtc-mega__link rtc-mega__link--state" data-state="' +
        state + '">' + state + '</button>';
    });
    listEl.innerHTML = html;

    listEl.querySelectorAll('[data-state]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var state = btn.getAttribute('data-state');
        currentState = state;
        showCodes(state);
      });
    });
  }

  // ============================================
  // Build state list (mobile)
  // ============================================
  function buildMobileStateList() {
    var listEl = container.querySelector('[data-mobile-states-list]');
    if (!listEl) return;
    var html = '';
    var states = Object.keys(STATE_CODES).sort();
    states.forEach(function(state) {
      html += '<button class="rtc-mega__link rtc-mega__link--state" data-mobile-state="' +
        state + '">' + state + '</button>';
    });
    listEl.innerHTML = html;

    listEl.querySelectorAll('[data-mobile-state]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var state = btn.getAttribute('data-mobile-state');
        currentState = state;
        showMobileCodes(state);
      });
    });
  }

  // ============================================
  // Show area codes (desktop — right panel)
  // ============================================
  function showCodes(state) {
    var title = container.querySelector('[data-codes-title]');
    title.textContent = 'CHOOSE YOUR AREA CODE';
    var stateLabel = container.querySelector('[data-codes-state]');
    if (stateLabel) stateLabel.textContent = state + ' ' + formatSport(currentSport);

    var listEl = container.querySelector('[data-codes-list]');
    var codes = STATE_CODES[state] || [];
    var html = '';
    codes.forEach(function(code) {
      var href = buildCollectionHref(currentSport, code);
      html += '<a href="' + href + '" class="rtc-mega__link rtc-mega__link--code" data-code="' +
        code + '">' + code + '</a>';
    });
    listEl.innerHTML = html;

    listEl.querySelectorAll('[data-code]').forEach(function(link) {
      link.addEventListener('click', function() {
        var code = link.getAttribute('data-code');
        setCookie('rtc_sport', currentSport, 30);
        setCookie('rtc_state', state, 30);
        setCookie('rtc_code', code, 30);
      });
    });

    showView('codes');
  }

  // ============================================
  // Show area codes (mobile)
  // ============================================
  function showMobileCodes(state) {
    var title = container.querySelector('[data-mobile-codes-title]');
    if (title) title.textContent = 'CHOOSE YOUR AREA CODE';
    var mobileCodesState = container.querySelector('[data-mobile-codes-state]');
    if (mobileCodesState) mobileCodesState.textContent = state + ' ' + formatSport(currentSport);

    var listEl = container.querySelector('[data-mobile-codes-list]');
    if (!listEl) return;
    var codes = STATE_CODES[state] || [];
    var html = '';
    codes.forEach(function(code) {
      var href = buildCollectionHref(currentSport, code);
      html += '<a href="' + href + '" class="rtc-mega__link rtc-mega__link--code" data-mobile-code="' +
        code + '">' + code + '</a>';
    });
    listEl.innerHTML = html;

    listEl.querySelectorAll('[data-mobile-code]').forEach(function(link) {
      link.addEventListener('click', function() {
        var code = link.getAttribute('data-mobile-code');
        setCookie('rtc_sport', currentSport, 30);
        setCookie('rtc_state', state, 30);
        setCookie('rtc_code', code, 30);
      });
    });

    showMobileScreen('codes');
  }

  // ============================================
  // Initialize
  // ============================================
  function init() {
    container = document.querySelector('[data-rtc-mega]');
    if (!container) return;

    // Add override class to drawer
    var drawer = container.closest('.drawer--header');
    if (drawer) {
      drawer.classList.add('rtc-drawer-override');
    }

    // Sport buttons — handle both desktop and mobile
    container.querySelectorAll('[data-sport]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        currentSport = btn.getAttribute('data-sport');
        currentState = null;

        highlightSport(currentSport);

        if (isMobile()) {
          // Mobile: slide in states screen
          var mobileTitle = container.querySelector('[data-mobile-states-title]');
          if (mobileTitle) mobileTitle.textContent = 'CHOOSE YOUR STATE';
          var mobileSportLabel = container.querySelector('[data-mobile-states-sport]');
          if (mobileSportLabel) mobileSportLabel.textContent = formatSport(currentSport);
          buildMobileStateList();
          showMobileScreen('states');
        } else {
          // Desktop: show states in right panel
          var title = container.querySelector('[data-states-title]');
          title.textContent = 'CHOOSE YOUR STATE';
          var sportLabel = container.querySelector('[data-states-sport]');
          if (sportLabel) sportLabel.textContent = formatSport(currentSport);
          buildStateList();
          showView('states');
        }
      });
    });

    // Desktop: Back buttons in right panel
    container.querySelectorAll('[data-right-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-right-back');
        showView(target);
        if (target === 'image') {
          clearHighlight();
          currentSport = null;
          currentState = null;
        }
      });
    });

    // Mobile: Back buttons
    container.querySelectorAll('[data-mobile-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-mobile-back');
        if (target === 'main') {
          // Go back to main menu
          hideMobileScreens();
          clearHighlight();
          currentSport = null;
          currentState = null;
        } else if (target === 'states') {
          // Go back to states screen
          showMobileScreen('states');
          currentState = null;
        }
      });
    });

    // Overlay element
    var overlay = document.querySelector('[data-rtc-overlay]');

    // Close menu when overlay is clicked
    if (overlay) {
      overlay.addEventListener('click', function() {
        var closeBtn = drawer.querySelector('[data-drawer-close]');
        if (closeBtn) closeBtn.click();
      });
    }

    // Watch drawer open/close for header + overlay state
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class' || mutation.attributeName === 'style') {
          var isOpen = drawer && (
            drawer.classList.contains('is-open') ||
            drawer.classList.contains('drawer--visible') ||
            (drawer.style.transform && drawer.style.transform.indexOf('none') > -1)
          );

          if (isOpen) {
            document.body.classList.add('rtc-menu-open');
            if (overlay) overlay.classList.add('is-visible');
          } else {
            document.body.classList.remove('rtc-menu-open');
            if (overlay) overlay.classList.remove('is-visible');

            // Reset to default state after close animation
            setTimeout(function() {
              showView('image');
              clearHighlight();
              hideMobileScreens();
              currentSport = null;
              currentState = null;
            }, 500);
          }
        }
      });
    });

    if (drawer) {
      observer.observe(drawer, { attributes: true });
    }

    // ============================================
    // Deep-link: ?openSport=training auto-opens the menu and pre-selects the sport
    // ============================================
    var openSport = new URLSearchParams(window.location.search).get('openSport');
    if (openSport) {
      // Clean URL so refresh/back doesn't re-trigger
      var cleanedUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanedUrl);

      var openMenu = function() {
        var hamburger = document.querySelector('[data-drawer-toggle="hamburger"]');
        if (hamburger) hamburger.click();
        // Wait for drawer animation then click the sport
        setTimeout(function() {
          var sportBtn = container.querySelector('[data-sport="' + openSport + '"]');
          if (sportBtn) sportBtn.click();
        }, 350);
      };
      // Run after layout settles
      setTimeout(openMenu, 100);
    }

    // ============================================
    // Takeover helper — reusable for both cards
    // ============================================
    function initTakeover(btnSelector, overlaySelector) {
      var overlay = document.querySelector(overlaySelector);
      var bg = overlay ? overlay.querySelector('[data-signup-bg]') : null;
      var btn = container.querySelector(btnSelector);

      if (!btn || !overlay || !bg) return;

      btn.addEventListener('click', function(e) {
        e.preventDefault();

        // Step 1: Fill the card black (left-to-right, 1s)
        btn.classList.add('is-filling');

        // Step 2: After card fills, expand to fullscreen
        setTimeout(function() {
          var rect = btn.getBoundingClientRect();

          bg.style.top = rect.top + 'px';
          bg.style.left = rect.left + 'px';
          bg.style.width = rect.width + 'px';
          bg.style.height = rect.height + 'px';
          bg.style.opacity = '1';

          bg.offsetHeight;

          bg.style.transition = 'top 0.5s cubic-bezier(0.16, 1, 0.3, 1), left 0.5s cubic-bezier(0.16, 1, 0.3, 1), width 0.5s cubic-bezier(0.16, 1, 0.3, 1), height 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
          bg.style.top = '0px';
          bg.style.left = '0px';
          bg.style.width = '100vw';
          bg.style.height = '100vh';

          setTimeout(function() {
            overlay.classList.add('is-active');
          }, 500);
        }, 1000);
      });

      var closeBtn = overlay.querySelector('[data-signup-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          overlay.classList.remove('is-active');

          var rect = btn.getBoundingClientRect();

          bg.style.transition = 'top 0.4s cubic-bezier(0.16, 1, 0.3, 1), left 0.4s cubic-bezier(0.16, 1, 0.3, 1), width 0.4s cubic-bezier(0.16, 1, 0.3, 1), height 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease 0.3s';
          bg.style.top = rect.top + 'px';
          bg.style.left = rect.left + 'px';
          bg.style.width = rect.width + 'px';
          bg.style.height = rect.height + 'px';
          bg.style.opacity = '0';

          setTimeout(function() {
            bg.style.cssText = '';
            btn.classList.remove('is-filling');
          }, 500);
        });
      }
    }

    // New athlete takeover
    initTakeover('[data-athlete-cta]', '[data-athlete-signup]');

    // Existing athlete portal takeover
    initTakeover('[data-portal-cta]', '[data-portal-signup]');
  }

  // ============================================
  // Mobile Menu (separate mobile-menu section)
  // ============================================
  function initMobile() {
    var mobileContainer = document.querySelector('[data-rtc-mobile]');
    if (!mobileContainer) return;

    var mobileCurrentSport = null;
    var mobileCurrentState = null;
    var mobileDrawerEl = mobileContainer.closest('header-drawer') || mobileContainer.closest('.drawer--header');

    // Screen switching
    function showScreen(name) {
      mobileContainer.querySelectorAll('[data-rtc-mobile-screen]').forEach(function(screen) {
        if (screen.getAttribute('data-rtc-mobile-screen') === name) {
          screen.classList.add('is-active');
        } else if (screen.getAttribute('data-rtc-mobile-screen') !== 'main') {
          screen.classList.remove('is-active');
        }
      });
      if (name !== 'main') {
        mobileContainer.classList.add('is-drilled');
        if (mobileDrawerEl) mobileDrawerEl.classList.add('rtc-mobile-drilled');
      } else {
        mobileContainer.classList.remove('is-drilled');
        if (mobileDrawerEl) mobileDrawerEl.classList.remove('rtc-mobile-drilled');
      }
    }

    function resetMobile() {
      mobileContainer.querySelectorAll('[data-rtc-mobile-screen]').forEach(function(screen) {
        if (screen.getAttribute('data-rtc-mobile-screen') !== 'main') {
          screen.classList.remove('is-active');
        }
      });
      mobileContainer.classList.remove('is-drilled');
      if (mobileDrawerEl) mobileDrawerEl.classList.remove('rtc-mobile-drilled');
      mobileCurrentSport = null;
      mobileCurrentState = null;
    }

    // Sport buttons
    mobileContainer.querySelectorAll('[data-rtc-mobile-sport]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        mobileCurrentSport = btn.getAttribute('data-rtc-mobile-sport');
        mobileCurrentState = null;

        var title = mobileContainer.querySelector('[data-rtc-mobile-states-title]');
        if (title) title.textContent = formatSport(mobileCurrentSport);
        var mobileLbl = mobileContainer.querySelector('[data-rtc-mobile-states-label]');
        if (mobileLbl) mobileLbl.textContent = 'CHOOSE YOUR STATE';

        // Build state list
        var listEl = mobileContainer.querySelector('[data-rtc-mobile-states-list]');
        if (listEl) {
          var html = '';
          var states = Object.keys(STATE_CODES).sort();
          states.forEach(function(state) {
            html += '<button class="rtc-mobile__link rtc-mobile__link--state" data-rtc-mobile-state="' +
              state + '">' + state + '</button>';
          });
          listEl.innerHTML = html;

          listEl.querySelectorAll('[data-rtc-mobile-state]').forEach(function(stateBtn) {
            stateBtn.addEventListener('click', function() {
              mobileCurrentState = stateBtn.getAttribute('data-rtc-mobile-state');
              showMobileCodes(mobileCurrentState);
            });
          });
        }

        showScreen('states');
      });
    });

    // Show codes for a state
    function showMobileCodes(state) {
      var title = mobileContainer.querySelector('[data-rtc-mobile-codes-title]');
      if (title) title.textContent = state + ' ' + formatSport(mobileCurrentSport);

      var listEl = mobileContainer.querySelector('[data-rtc-mobile-codes-list]');
      if (!listEl) return;
      var codes = STATE_CODES[state] || [];
      var html = '';
      codes.forEach(function(code) {
        var href = buildCollectionHref(mobileCurrentSport, code);
        html += '<a href="' + href + '" class="rtc-mobile__link rtc-mobile__link--code" data-rtc-mobile-code="' +
          code + '">' + code + '</a>';
      });
      listEl.innerHTML = html;

      listEl.querySelectorAll('[data-rtc-mobile-code]').forEach(function(link) {
        link.addEventListener('click', function() {
          var code = link.getAttribute('data-rtc-mobile-code');
          setCookie('rtc_sport', mobileCurrentSport, 30);
          setCookie('rtc_state', state, 30);
          setCookie('rtc_code', code, 30);
        });
      });

      showScreen('codes');
    }

    // Back buttons
    mobileContainer.querySelectorAll('[data-rtc-mobile-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-rtc-mobile-back');
        if (target === 'main') {
          resetMobile();
        } else {
          showScreen(target);
        }
      });
    });

    // Takeover for mobile CTA cards
    function initMobileTakeover(btnSelector, overlaySelector) {
      var overlay = document.querySelector(overlaySelector);
      var bg = overlay ? overlay.querySelector('[data-signup-bg]') : null;
      var btn = mobileContainer.querySelector(btnSelector);

      if (!btn || !overlay || !bg) return;

      btn.addEventListener('click', function(e) {
        e.preventDefault();

        // Step 1: Fill the card black (left-to-right, 1s)
        btn.classList.add('is-filling');

        // Step 2: After card fills, expand to fullscreen
        setTimeout(function() {
          var rect = btn.getBoundingClientRect();
          bg.style.top = rect.top + 'px';
          bg.style.left = rect.left + 'px';
          bg.style.width = rect.width + 'px';
          bg.style.height = rect.height + 'px';
          bg.style.opacity = '1';
          bg.offsetHeight;
          bg.style.transition = 'top 0.5s cubic-bezier(0.16, 1, 0.3, 1), left 0.5s cubic-bezier(0.16, 1, 0.3, 1), width 0.5s cubic-bezier(0.16, 1, 0.3, 1), height 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
          bg.style.top = '0px';
          bg.style.left = '0px';
          bg.style.width = '100vw';
          bg.style.height = '100vh';
          setTimeout(function() { overlay.classList.add('is-active'); }, 500);
        }, 1000);
      });

      var closeBtn = overlay.querySelector('[data-signup-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          overlay.classList.remove('is-active');
          var rect = btn.getBoundingClientRect();
          bg.style.transition = 'top 0.4s cubic-bezier(0.16, 1, 0.3, 1), left 0.4s cubic-bezier(0.16, 1, 0.3, 1), width 0.4s cubic-bezier(0.16, 1, 0.3, 1), height 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease 0.3s';
          bg.style.top = rect.top + 'px';
          bg.style.left = rect.left + 'px';
          bg.style.width = rect.width + 'px';
          bg.style.height = rect.height + 'px';
          bg.style.opacity = '0';
          setTimeout(function() {
            bg.style.cssText = '';
            btn.classList.remove('is-filling');
          }, 500);
        });
      }
    }

    initMobileTakeover('[data-athlete-cta]', '[data-athlete-signup]');
    initMobileTakeover('[data-portal-cta]', '[data-portal-signup]');

    // Reset on drawer close
    var mobileDrawer = mobileContainer.closest('header-drawer');
    if (mobileDrawer) {
      var mobileObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class' || mutation.attributeName === 'style') {
            var isOpen = mobileDrawer.classList.contains('is-open') ||
              mobileDrawer.classList.contains('drawer--visible');
            if (!isOpen) {
              setTimeout(resetMobile, 400);
            }
          }
        });
      });
      mobileObserver.observe(mobileDrawer, { attributes: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      initMobile();
    });
  } else {
    init();
    initMobile();
  }
})();
